import React, { useEffect, useRef, useState } from 'react';

import { skills, status } from '../../utils/fitersAttributes';

import { useFilter } from '../../hooks/FilterContext'

import { FiChevronDown } from 'react-icons/fi';
import { FaCheck } from 'react-icons/fa';

import { Container, Checkbox, Popover } from './styles';

const Select = ({ name, type }) => {
  const { setSkillValue, skillValue, statusValue, setStatusValue } = useFilter()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [skillsList, setSkillsList] = useState(skills);
  const [statusList, setStatusList] = useState(status);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleDropdown = event => {
      if (buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        isDropdownOpen
      ) setIsDropdownOpen(!isDropdownOpen);
    }

    document.addEventListener('mousedown', handleDropdown);

    return () => document.removeEventListener('mousedown', handleDropdown);
  }, [buttonRef, isDropdownOpen]);

  const handleWitchIsChecked = (self) => {

    if (type === "skill") {
      setSkillsList((list) => list.map((skill) => {
        return ({ ...skill, selected: false })
      }))

      setSkillsList((list) => list.map((skill) => {
        return ({
          ...skill,
          selected: (skill.name === self.name) ?
            !self.selected :
            skill.selected
        })
      }))

      setSkillValue(self)
      setIsDropdownOpen(false)
    }
    if (type === "status") {
      setStatusList((list) => list.map((status) => {
        return ({ ...status, selected: false })
      }))
      
      setStatusList((list) => list.map((skill) => {
        return ({
          ...skill,
          selected: (skill.name === self.name) ?
            !self.selected :
            skill.selected
        })
      }))
      setStatusValue(self)
      setIsDropdownOpen(false)
    }
  }

  useEffect(() => {
    let isSkillChecked = skillsList.map((skill) => skill.selected).reduce((total, selected) => (total + selected), false);
    if (isSkillChecked === 0) setSkillValue("");
  }, [skillsList])

  useEffect(() => {
    let isStatuschecked = statusList.map((status) => status.selected).reduce((total, selected) => (total + selected), false);
    if (isStatuschecked === 0) setStatusValue("");
  }, [statusList])

  return (

    <Container ref={buttonRef}>
      <button ref={buttonRef} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
        {type === "skill" && skillValue ?
          <label>{skillValue.name}</label> :
          (type === "status" && statusValue) ?
            <label>{statusValue.name}</label> :
            <label>{name}</label>}
        <FiChevronDown color="rgb(3, 191, 202)" size={20} />
      </button>
      <Popover ref={buttonRef} isFocused={isDropdownOpen} diferrentheight={type}>
        {isDropdownOpen && (
          (type === "skill") ? (
            skillsList.map(skill => (
              <Checkbox isActive={skill.selected} key={skill.id}>
                <button type="button" onClick={() => handleWitchIsChecked(skill)}>
                  <span>{skill.name}</span>
                  <div>
                    {skill.selected && <FaCheck color="#fff" size={18} />}
                  </div>
                </button>
              </Checkbox>
            ))) : (
            statusList.map(skill => (
              <Checkbox isActive={skill.selected} key={skill.id}>
                <button type="button" onClick={() => handleWitchIsChecked(skill)}>
                  <span>{skill.name}</span>
                  <div>
                    {skill.selected && <FaCheck color="#fff" size={18} />}
                  </div>
                </button>
              </Checkbox>
            )))
        )}
      </Popover>
    </Container>
  );
}

export default Select;
